import { CButton, CButtonGroup } from '@coreui/react-pro'
import React from 'react'
import './TabInputs.scss'

const TabInputs = ({ tabList, selectedTab, setSelectedTab }) => {
  return (
    <div className="tab-inpits">
      <CButtonGroup role="group">
        {tabList?.map((item, index) => (
          <CButton
            color={`${selectedTab === index ? 'primary' : 'gray'}`}
            key={index}
            onClick={() => setSelectedTab(index)}
          >
            {item}
          </CButton>
        ))}
      </CButtonGroup>
    </div>
  )
}

export default TabInputs
